import {SingleCompetitorType} from '@/store/content-optimizer/CurrentPageModel';
import {getProgressColor} from '@/utils/colors';
import {numberWithCommas} from '@/utils/number';
import {Progress, Tooltip} from 'antd';
import {observer} from 'mobx-react';
import styles from '../style.module.scss';
import {NextImg} from '@/utils/nextImg';

interface Props {
  competitor: SingleCompetitorType;
  loading: boolean;
}

export const SingleCompetitor = observer(({competitor, loading}: Props) => {
  // const addDefaultSrc = e => {
  //   e.target.src = '/img/world-wide-web.svg';
  // };

  return <div className={styles.singleCompetitor}>
    <div className={styles.competitorIcon}>{competitor.url && <NextImg
    // onError={e => addDefaultSrc(e)}
      height={20}
      width={20}
      src={`https://www.google.com/s2/favicons?sz=16&domain_url=${competitor.url}`} />}</div>
    <div className={styles.competitorInfo}>
      <Tooltip overlayClassName={styles.tooltipOverlay} title={<a href={competitor?.url} className={styles.competitorTooltipUrl} target='_blank' rel='noreferrer'>{competitor?.url}</a>}>
        <a href={competitor?.url} target='_blank' rel='noreferrer' className={styles.competitorName}>{competitor?.title}</a>
      </Tooltip>

      <div className={styles.competitorDetailsContainer}>

        <Tooltip overlayClassName={styles.tooltipOverlay} title='Position'>
          <span className={styles.competitorPosition}>{`#${competitor?.position}`}</span>
        </Tooltip>

        <span className={styles.splitter}>{`-`}</span>

        <Tooltip title='Content score'>
          <span className={styles.competitorContentScore}>
            {competitor?.contentScore}
            <Progress
              percent={!loading ? competitor?.contentScore ?? 0 : 50}
              strokeLinecap='round'
              gapDegree={0}
              trailColor='#4E5156'
              strokeColor={!loading ? getProgressColor(competitor?.contentScore, 25, 50, 75) : '#7E8184'}
              // showInfo={true}
              type='circle'
              width={12}
              strokeWidth={18}
              size='small'
              format={() => <span style={{display: 'none'}}></span>}
              className={styles.progress}
            />
          </span>
        </Tooltip>

        <span className={styles.splitter}>{`-`}</span>

        <Tooltip title='Word count'>
          <span className={styles.competitorWordCount}>
            {`${numberWithCommas(competitor?.wordCount) || 0} words`}
          </span>
        </Tooltip>
      </div>
      {/* {competitor?.url && urlValidationRegex.test(competitor?.url) ?
        <a target='_blank' rel='noreferrer' href={competitor?.url} className={styles.competitorUrl}>{competitor?.url}</a> : null} */}

      {/* <div className={styles.competitorText}>{competitor?.metaDesc && competitor?.metaDesc.length > 90 ? competitor?.metaDesc.substring(0, 90) + '...' : competitor?.metaDesc}</div> */}
    </div>
  </div>;
});
